import { render, staticRenderFns } from "./BusinessStatus.vue?vue&type=template&id=99ac3cb8"
import script from "./BusinessStatus.vue?vue&type=script&lang=js"
export * from "./BusinessStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports